import React from "react";
import { Link } from "react-router-dom";
import "./Thankyou.css";

const ThankYou = () => {
  return (
    <div
      className="ty-wrap"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/images/logistic.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="ty-card">

        {/* Icon */}
        <div className="ty-icon-ring">
          <i className="bx bx-check-circle"></i>
        </div>

        {/* Badge */}
        <span className="ty-badge">Registration Submitted</span>

        {/* Heading */}
        <h2 className="ty-title">Thank you for registering!</h2>

        <p className="ty-sub">
          Your application has been received. Our team will review it and
          notify you via email once it's approved.
        </p>

        {/* What happens next */}
        <div className="ty-steps">
          <div className="ty-step ty-step-done">
            <span className="ty-step-num"><i className="bx bx-check" style={{ fontSize: '0.8rem' }}></i></span>
            <span>Registration form submitted successfully</span>
          </div>
          <div className="ty-step">
            <span className="ty-step-num">2</span>
            <span>Admin reviews your application</span>
          </div>
          <div className="ty-step">
            <span className="ty-step-num">3</span>
            <span>You receive approval email with login credentials</span>
          </div>
        </div>

        {/* CTA */}
        <Link to="/" className="ty-btn">
          <i className="bx bx-log-in"></i> Back to Login
        </Link>

        <p className="ty-foot">
          Questions? Contact us at <strong>support@demonmm.com</strong>
        </p>

      </div>
    </div>
  );
};

export default ThankYou;
